import { render, staticRenderFns } from "./otherService.vue?vue&type=template&id=128565fe&scoped=true"
import script from "./otherService.vue?vue&type=script&lang=js"
export * from "./otherService.vue?vue&type=script&lang=js"
import style0 from "./otherService.vue?vue&type=style&index=0&id=128565fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128565fe",
  null
  
)

export default component.exports